export class UserModel {
  id?: number;

  username!: string;

  name!: string;

  password?: string;

  active!: boolean;

  permissions!: number;
}
